// extracted by mini-css-extract-plugin
export default {"btn":"buttonComponent_btn__dMZFi","large":"buttonComponent_large__4lEKs"};